import React from "react";
import Carousel from "react-bootstrap/Carousel";
import Button from "react-bootstrap/Button";
import image1 from "../images/home/banner-1.jpg";
import image2 from "../images/home/banner-2.jpg";
import image3 from "../images/home/banner-3.jpg";
// TODO: UPDATE IMAGES

// This Banner uses a full-cover image with a dark overlay for readability.
// All layout uses Bootstrap utilities; images are lazy-loaded and cropped with object-fit.

export const Banner = () => {
  const CONSULT_URL =
    "https://login.high1digital.com/u/64804/discovery-call--6dpm9wokt7";

  const ConsultButton = () => (
    <Button
      as="a"
      href={CONSULT_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-banner btn-lg text-white text-decoration-none"
      aria-label="Free Consultation - opens in a new tab"
    >
      Free Consultation
    </Button>
  );

  // Inline styles used to keep component self-contained and avoid extra CSS files.
  const overlayStyle = {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.55) 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem 1rem",
  };

  const captionContainerStyle = {
    zIndex: 2,
    color: "#fff",
  };

  const imgStyle = {
    objectFit: "cover",
    width: "100%",
    height: "min(80vh, 650px)",
  };

  return (
    <Carousel
      variant="dark"
      controls
      indicators
      interval={5000}
      pause="hover"
      keyboard
      touch
    >
      <Carousel.Item>
        <div style={{ position: "relative" }}>
          <img
            className="d-block w-100 img-fluid"
            src={image1}
            alt="Admissions growth background"
            loading="lazy"
            style={imgStyle}
          />

          <div
            style={overlayStyle}
            aria-hidden="true"
          />

          <div style={{ ...overlayStyle, background: "transparent" }}>
            <div
              style={captionContainerStyle}
              className="container"
            >
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-7 text-center text-md-start">
                  <h1
                    className="display-5 fw-bold mb-1"
                    style={{ color: "red" }}
                  >
                    Admissions Growth
                  </h1>
                  <h2 className="display-6 fw-bold mb-3">Made Simple</h2>

                  <p className="lead mb-3">
                    From Lead Generation to WhatsApp Automation — We Help
                    Schools, Colleges, and Coaching Institutes Get More
                    Admissions with Our Done-For-You System.
                  </p>

                  <div className="d-inline-block mt-2">
                    <ConsultButton />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div style={{ position: "relative" }}>
          <img
            className="d-block w-100 img-fluid"
            src={image3}
            alt="Tech and WhatsApp marketing background"
            loading="lazy"
            style={imgStyle}
          />

          <div
            style={overlayStyle}
            aria-hidden="true"
          />

          <div style={{ ...overlayStyle, background: "transparent" }}>
            <div
              style={captionContainerStyle}
              className="container"
            >
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-7 text-center text-md-start">
                  <h1
                    className="display-5 fw-bold mb-1"
                    style={{ color: "red" }}
                  >
                    Tech and WhatsApp Marketing
                  </h1>
                  <h2 className="h3 fw-bold mb-3">For Schools and Colleges</h2>

                  <p className="lead mb-3">
                    Power Your Admissions with Smart Tech + Real-Time WhatsApp
                    Automation
                  </p>

                  <div className="d-inline-block mt-2">
                    <ConsultButton />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div style={{ position: "relative" }}>
          <img
            className="d-block w-100 img-fluid"
            src={image2}
            alt="Better insights for institutes background"
            loading="lazy"
            style={imgStyle}
          />

          <div
            style={overlayStyle}
            aria-hidden="true"
          />

          <div style={{ ...overlayStyle, background: "transparent" }}>
            <div
              style={captionContainerStyle}
              className="container"
            >
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-7 text-center text-md-start">
                  <h1 className="display-5 fw-bold mb-1">We provide</h1>
                  <h2
                    className="h3 fw-bold mb-3"
                    style={{ color: "red" }}
                  >
                    Better Insights for institutes.
                  </h2>

                  <p className="lead mb-3">
                    We create and build flexible &amp; creative design in your
                    budget. Helping you get increase in sales.
                  </p>

                  <div className="d-inline-block mt-2">
                    <ConsultButton />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Carousel.Item>
    </Carousel>
  );
};

export default Banner;
